import {
  AUTHENTICATE_FIGMA_REQUEST, AUTHTENTICATING_FIGMA_SUCCEEDED, AUTHTENTICATING_FIGMA_FAILED,
  FETCH_FIGMA_FRAMES_REQUEST, FETCHING_FIGMA_FRAMES_SUCCEEDED, FETCHING_FIGMA_FRAMES_FAILED, 
  UPDATE_FIGMA_SELECTION, INVALIDATE_FIGMA
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  figmaFile:{
    loading: false,
    error: false
  },
  changes: {
    saving: false,
    error: null
  },
};

function figmaReducer(state = initialState, action) {
  switch (action.type) {

    case AUTHENTICATE_FIGMA_REQUEST: {
      return {
        ...state,
        changes: {
          ...state.changes,
          saving: true,
          error: null
        }
      }
    }

    case AUTHTENTICATING_FIGMA_SUCCEEDED: {
      return {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          error: null
        }
      }
    }

    case AUTHTENTICATING_FIGMA_FAILED: {
      return {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          error: action.payload
        }
      }
    }

    case FETCH_FIGMA_FRAMES_REQUEST: {
      const { fileUid, fileLink } = action.payload;

      return {
        ...state,
        figmaFile: {
          ...state.figmaFile,
          fileUid: fileUid,
          fileLink: fileLink,
          loading: true,
          success: false,
          error: false
        }
      }
    }

    case FETCHING_FIGMA_FRAMES_SUCCEEDED: {
      const { response } = action.payload;

      if(!response){
        return
      }

      const fileName = _.get(response, 'name', null);
      const fonts = _.get(response, 'fonts', [])

      let pages = _.get(response, 'children', []);
      pages = pages.map((page)=>{
        return {
          pageId: page.id,
          pageName: page.name,
          frames: (page.children || []).map((frame)=>{
            return{
              frameId: frame.id,
              name: frame.name,
              thumbnailUrl: frame.thumbnailUrl
            }
          })
        }
      })

      return {
        ...state,
        figmaFile: {
          ...state.figmaFile,
          fileName: fileName,
          pages: pages,
          fonts: fonts,
          loading: false,
          success: true,
          error: false
        }
      }
    }

    case FETCHING_FIGMA_FRAMES_FAILED: {

      return {
        ...state,
        figmaFile: {
          loading: false,
          success: false,
          error: true
        }
      }
    }

    case UPDATE_FIGMA_SELECTION: {
      const { request } = action.payload;

      return {
        ...state,
        figmaFile: {
          ...state.figmaFile,
          selected:{
            ...state.figmaFile.selected,
            ...request
          }
        }
      }
    }

    case INVALIDATE_FIGMA: {
      return {
        ...state,
        figmaFile: {}
      }
    }

    default:
      return state;
  }
}

export { figmaReducer };